const des_bloquear_geracao_da_estimativa_matricula = {
  path: "/des-bloquear-geracao-da-estimativa-matricula",
  redirect: "/des-bloquear-geracao-da-estimativa-matricula",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Des/Bloquear Geração da Estimativa Matrícula",
  },
  children: [
    {
      path: "/des-bloquear-geracao-da-estimativa-matricula",
      name: "des-bloquear-geracao-da-estimativa-matricula",
      component: () =>
        import(
          "@/views/DesBloquearGeracaoDaEstimativaMatricula/DesBloquearGeracaoDaEstimativaMatricula.vue"
        ),
    },
  ],
};

export { des_bloquear_geracao_da_estimativa_matricula };
